var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-052d1b67-7fde-4e4b-adb6-ddc69a7f7523",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-d86365cb-280a-4997-b8fc-c6f38937514c {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d86365cb-280a-4997-b8fc-c6f38937514c",
    d: "M17.63,9.04h-4.57c-1.16,0-2.1.94-2.1,2.1v9.72c0,1.16.94,2.1,2.1,2.1h5.88c1.16,0,2.1-.94,2.1-2.1v-8.61l-3.41-3.21ZM19.04,20.86c0,.06-.05.1-.1.1h-5.88c-.06,0-.1-.05-.1-.1v-9.72c0-.06.05-.1.1-.1h3.77l2.21,2.08v7.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d86365cb-280a-4997-b8fc-c6f38937514c",
    d: "M16.75,14.39c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.86h-.86c-.41,0-.75.34-.75.75s.34.75.75.75h.86v.86c0,.41.34.75.75.75s.75-.34.75-.75v-.86h.86c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-.86v-.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFile);
export default __webpack_public_path__ + "static/media/OpenFile.cf7817b32d8dd01fe9e7f533a0aefd2d.svg";
export { ForwardRef as ReactComponent };